import { CellTemplate, Compatible, Uncertain } from "@silevis/reactgrid";
import { ReactNode } from "react";
import { CellCustomType } from "@lhd/components/CloneApp/pages/SheetApp/type";
import Button from "@lhd/components/Button";

export class TableToggleCellTemplate implements CellTemplate<CellCustomType> {
  constructor(private onToggle: () => void, private isCollapsed: boolean) {}

  getCompatibleCell(
    uncertainCell: Uncertain<CellCustomType>,
  ): Compatible<CellCustomType> {
    return { value: NaN, ...(uncertainCell as CellCustomType) };
  }

  handleKeyDown(cell: Compatible<CellCustomType>) {
    return { cell, enableEditMode: false };
  }

  update(
    cell: Compatible<CellCustomType>,
    _cellToMerge: Compatible<CellCustomType>,
  ): Compatible<CellCustomType> {
    return this.getCompatibleCell({ ...cell });
  }

  getClassName(): string {
    return "";
  }

  render(): ReactNode {
    return null;
  }
}
